import React from 'react';
import { cn } from '../../lib/utils';
interface ProgressProps {
  value: number;
  className?: string;
}
export function Progress({
  value,
  className
}: ProgressProps) {
  return <div className={cn('w-full bg-neutral-100 rounded-full overflow-hidden h-2', className)} data-id="element-395">
      <div className="h-full bg-atios-primary rounded-full transition-all duration-500 ease-out" style={{
      width: `${Math.min(100, Math.max(0, value))}%`
    }} data-id="element-396" />
    </div>;
}